export default [
    {
        path: '/questionnaire/List',
        component: (resolve) => require(['@/components/questionnaire/List'],resolve),
        meta: {
            title: '问卷调查列表'
        },
    },
    {
        path: '/questionnaire/Form',
        component: (resolve) => require(['@/components/questionnaire/Form'],resolve),
        meta: {
            title: '问卷调查表单'
        },
    },
]


// WEBPACK FOOTER //
// ./src/router/questionnaire.js